import styles from './DigitalInnovationSupport.module.scss'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

const tweenVars: gsap.TimelineVars = {
  y: '50',
  duration: 1,
  opacity: 0,
  ease: Power4.easeOut,
}

const DigitalInnovationSupport: React.FC = () => {
  const timeline = gsap.timeline()
  const EN_title = useRef<HTMLDivElement>(null)
  const JP_title = useRef<HTMLDivElement>(null)
  const text = useRef<HTMLDivElement>(null)
  const img = useRef<HTMLImageElement>(null)
  const supports = useRef<HTMLDivElement[]>([])

  useEffect(() => {
    timeline
      .from(img.current, tweenVars, 0.1)
      .from(EN_title.current, tweenVars, 0.1)
      .from(JP_title.current, tweenVars, 0.3)
      .from(text.current, tweenVars, 0.5)

    // supports配列を一括でアニメーションし、各要素の開始時間をずらす
    timeline.from(supports.current, {
      ...tweenVars,
      stagger: 0.2,
    })

    ScrollTrigger.create({
      animation: timeline,
      trigger: EN_title.current,
      start: 'top-=150 80%',
      toggleActions: 'play none none reverse',
    })

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
      timeline.kill()
    }
  }, [])

  const services = [
    {
      href: '/services/strategy',
      title: '事業戦略策定',
      body: 'デジタル戦略・イノベーション戦略・新規事業戦略・ブランディング戦略・マーケティング戦略など、企業の成長と競争力強化を目的とした重要戦略の策定に向けた支援を行います。',
    },
  ]

  return (
    <section className={styles.contents} id='degital-innovation-support'>
      <div className={styles.head}>
        <figure className={`${styles.head_icon} head_icon_anim`}>
          <img ref={img} src="/images/icons/icon_digital_innovation support.svg" alt="Digital innovation support" />
        </figure>
        <div className={styles.head_title}>
          <h2 ref={EN_title} className={styles.head_title_en}>
            Digital innovation <br className={styles.is_sp} />
            support
          </h2>
          <h3 ref={JP_title} className={styles.head_title_ja}>
            デジタルイノベーションサポート
          </h3>
        </div>
      </div>
      <p ref={text} className={styles.head_title_text}>
        企業の成長と競争力強化を目的とした重要戦略のコンサルティングやプロダクトグロースのためのPdM支援、デジタル分野における新規事業創出、クラウド基盤ならびにAIを活用したDX戦略策定などを提供します。
      </p>
      <div className={styles.supports}>
        {services.map((service, index) => (
          <div key={index} ref={(el) => (supports.current[index] = el)} className={styles.support}>
            <a href={service.href}>
              <div className={styles.wrapper}>
                <span className={styles.dot}></span>
                <div className={styles.textWrapper}>
                  <h4 className={styles.title}>{service.title}</h4>
                  <p className={styles.description}>{service.body}</p>
                </div>
              </div>
              <span className={styles.viewmore}>Read more</span>
            </a>
          </div>
        ))}
      </div>
    </section>
  )
}

export default DigitalInnovationSupport
